import React from 'react';
import { Icon, Text } from '../../Atoms';
import ContractList from '../../Molecules/MoleculeContract/ContractList';
import useContracts from './Contracts.hook';
import ContractDetails from './ContractDetails';
import ContractMenu from '../../Molecules/MoleculeContract/ContractMenu';

export default function Contracts(props) {
  const {
    contracts,
    user,
    selectedContract,
    handleSelectContract,
    handleDeselectContract,
    activeMenu,
    setActiveMenu
  } = useContracts();

  return (
    <div className="template-container template-send-document template-scroll">
      <div className="container-title-send-doc">
        <Icon
          icon="SortTop"
          size="20px"
          className="icon-return"
          onClick={
            selectedContract
              ? () => handleSelectContract()
              : () => props.history.push('/documents')
          }
        />
        <Text text="Contrats" className="title-send-document" />
      </div>
      <div className="content-template-type-document">
        {selectedContract ? (
          <>
            <ContractMenu onMenuChange={setActiveMenu} />
            <ContractDetails
              contract={selectedContract}
              activeMenu={activeMenu}
              user={user}
              onBack={handleDeselectContract}
            />
          </>
        ) : (
          <ContractList
            contracts={contracts}
            onSelectContract={handleSelectContract}
            user={user}
          />
        )}
      </div>
    </div>
  );
}
